import React from "react";
import pdf from './resources/pdf.pdf';

import BasePdf from "../Base/pdf";

const LicensingModulePdf = () => {
    return <BasePdf
        pdf={pdf}
    >
        JAK TO TEDY JE<br/>
        Není licencování jako licencování. Problematika licencování v akademickém prostředí je specifickou oblastí,
        která se, pokud jde o cíle a motivaci aktérů, zdroje právní regulace a praktické otázky, do značné míry liší od
        běžné praxe v podnikatelské sféře.<br/>
        Hlavní odlišností je to, že v akademické sféře nemusí být primárním cílem vždy a výhradně nejefektivnější
        transfer technologií a znalostí za účelem maximalizace zisku a pokrytí nákladů výzkumu a vývoje. Pakliže ovšem
        máme své vlastní technické řešení či vlastní know-how, které patří nám jako fyzické osobě či naší právnické
        osobě, tak se samozřejmě o maximalizaci zisku snažit budeme.<br/>
        Hned na začátku si je dobré udělat pořádek v terminologii. Vymezíme si základní tři typy transakcí, se kterými
        se můžeme setkat v oblasti transferu technologií a znalostí, které jsou buď licencemi, anebo jsou licencím
        blízké. Za prvé jde o licence v pravém slova smyslu, dále o převody majetkových práv k předmětům duševního
        vlastnictví, a nakonec o dohody spoluvlastníků práv k duševnímu vlastnictví.<br/>
        LICENCE<br/>
        Prvním typem transakcí jsou licenční smlouvy nebo také licence. Jde o typ smluv, kterými nedochází k převodu
        vlastnictví (nebo přesněji majetkových práv) k předmětům práv duševního vlastnictví, ale pouze k převodu práv
        užívacích. Obdobou licence v oblasti hmotného majetku je nájem. Stejně tak jako si nájmem můžeme zajistit
        užívací právo například k nemovitosti (můžeme si třeba pronajmout kancelář a podnikat v ní), je možné si licencí
        „pronajmout“ práva k vynálezu a například vyrábět a prodávat novou technologii.<br/>
        Licenční smlouva je v českém právním řádu upravena především v občanském zákoníku (zákon č . 89/2012 Sb.),
        zejména v ustanoveních § 2358 a následujících. Licenční smlouvou uděluje poskytovatel licence užívacího práva k
        nehmotnému statku nabyvateli licence. Nabyvatel licence je zpravidla povinen za nabytí těchto práv uhradit
        poskytovateli práv odměnu.<br/>
        Licence<br/>
        Pododdíl 1<br/>
        Obecná ustanovení<br/>
        § 2358<br/>
        Základní ustanovení<br/>
        (1 ) Licenční smlouvou poskytuje poskytovatel nabyvateli oprávnění k výkonu práva duševního vlastnictví
        (licenci) v ujednaném omezeném nebo neomezeném rozsahu a nabyvatel se zavazuje, není-li ujednáno jinak,
        poskytnout poskytovateli odměnu.<br/>
        (2 ) Smlouva vyžaduje písemnou formu,<br/>
        a ) poskytuje-li se licence výhradní, nebo<br/>
        b ) má-li být licence zapsána do příslušného veřejného seznamu.<br/>
        (3 ) Licence k předmětu průmyslového vlastnictví zapsanému do veřejného seznamu je účinná vůči třetím osobám
        zápisem do tohoto seznamu.<br/>
        § 2359<br/>
        (1 ) Nabyvatel není povinen licenci využít, ledaže trvání práva závisí na jeho výkonu.<br/>
        (2 ) Poskytovatel udržuje po dobu trvání licence právo, vyžaduje-li to jeho povaha.<br/>
        <br/>
        § 2360<br/>
        Výhradní nebo nevýhradní licence<br/>
        (1 ) Je-li ujednána výhradní licence, poskytovatel nemá právo poskytnout tutéž licenci třetí osobě po dobu, co
        výhradní licence trvá. Není-li výslovně ujednán opak, zdrží se i poskytovatel výkonu práva, ke kterému udělil
        výhradní licenci.<br/>
        (2 ) Poskytne-li poskytovatel za trvání výhradní licence nabyvatele bez jeho souhlasu uděleného v písemné formě
        licenci třetí osobě, licence nevznikne. Byla-li však nevýhradní licence poskytnuta před poskytnutím výhradní
        licence, zůstává zachována.<br/>
        § 2361<br/>
        Je-li ujednána nevýhradní licence, je poskytovatel oprávněn k výkonu práva, ke kterému udělil nevýhradní
        licenci, jakož i poskytnout licenci třetí osobě.<br/>
        § 2362<br/>
        Není-li výslovně ujednána výhradní licence, platí, že se jedná o nevýhradní licenci.<br/>
        § 2363<br/>
        Podlicence<br/>
        Nabyvatel může oprávnění tvořící součást licence poskytnout třetí osobě zcela nebo zčásti, jen bylo-li to
        ujednáno v licenční smlouvě.<br/>
        § 2364<br/>
        (1 ) Nabyvatel může licenci postoupit třetí osobě zcela nebo zčásti jen se souhlasem poskytovatele. Souhlas
        vyžaduje písemnou formu.<br/>
        (2 ) Nabyvatel sdělí poskytovateli bez zbytečného odkladu, že licenci postoupil, jakož i osobu postupníka.<br/>
        § 2365<br/>
        Byl-li převeden závod nebo jeho část, která tvoří jeho samostatnou složku, souhlas poskytovatele k převedení
        licence se vyžaduje, jen bylo-li to zvlášť ujednáno.<br/>
        <br/>
        § 2366<br/>
        Odměna<br/>
        (1 ) Není-li ujednána výše odměny nebo způsob jejího určení, je smlouva přesto platná, pokud<br/>
        a ) z jednání stran o uzavření smlouvy vyplývá jejich vůle uzavřít úplatnou smlouvu i bez určení výše odměny; v
        takovém případě nabyvatel poskytovateli zaplatí odměnu ve výši, která je obvyklá v době uzavření smlouvy za
        obdobných smluvních podmínek a pro takové právo, nebo<br/>
        b ) strany ve smlouvě ujednají, že se licence poskytuje bezúplatně.<br/>
        (2 ) Je-li výše odměny ujednána v závislosti na výnosech z využití licence, umožní nabyvatel poskytovateli
        kontrolu příslušných účetních záznamů nebo jiné dokumentace ke zjištění skutečné výše odměny. Poskytne-li takto
        nabyvatel poskytovateli informace označené nabyvatelem jako důvěrné, nesmí je poskytovatel prozradit třetí osobě
        ani je použít pro své potřeby v rozporu s účelem, ke kterému mu byly poskytnuty.<br/>
        (3 ) Nabyvatel předloží poskytovateli pravidelná vyúčtování odměny podle odstavce 2 v ujednaných časových
        obdobích; není-li ujednáno jinak, je povinen tak učinit alespoň jednou ročně.<br/>
        § 2367<br/>
        Poskytovatel poskytne nabyvateli bez zbytečného odkladu po uzavření smlouvy veškeré podklady a informace
        potřebné k výkonu licence.<br/>
        § 2368<br/>
        (1 ) Nabyvatel utají před třetími osobami podklady a sdělení, jichž se mu od poskytovatele dostalo, ledaže ze
        smlouvy nebo z povahy podkladů a sdělení vyplývá, že poskytovatel nemá na jejich utajování zájem. Za třetí osobu
        se nepovažuje zaměstnanec ani ten, kdo se na podnikání podnikatele účastní, byl-li podnikatelem zavázán k
        mlčenlivosti.<br/>
        (2 ) Po zániku licence nabyvatel poskytnuté podklady vrátí; sdělení utají až do doby, kdy se stanou obecně
        známými.<br/>
        § 2369<br/>
        Dojde-li k ohrožení nebo porušení nabyvatelovy licence, zpraví o tom nabyvatel poskytovatele bez zbytečného
        odkladu, jakmile se o tom dozví. Poskytovatel poskytne nabyvateli součinnost k právní ochraně jeho licence.<br/>
        § 2370<br/>
        Výpověď<br/>
        Je-li smlouva uzavřena na dobu neurčitou, nabývá výpověď účinnosti uplynutím jednoho roku od konce kalendářního
        měsíce, v němž výpověď došla druhé straně.<br/>
        <br/>
        Licenční smlouva k vynálezu, který je chráněn patentem, je upravena také v zákoně č . 527/1990 Sb., o
        vynálezech, průmyslových vzorech a zlepšovacích návrzích.<br/>
        <br/>
        § 14<br/>
        (1 ) Souhlas (licence) k využívání vynálezu chráněného patentem se poskytuje písemnou smlouvou (dále jen
        "licenční smlouva").<br/>
        (2 ) Licenční smlouva nabývá účinnosti vůči třetím osobám zápisem do patentového rejstříku (§ 69).<br/>
        § 16<br/>
        Spolumajitelství patentu<br/>
        (1 ) Přísluší-li práva z téhož patentu několika osobám (dále jen "spolumajitelé"), spravují se vztahy mezi nimi
        obecnými předpisy o podílovém spoluvlastnictví.<br/>
        (2 ) Pokud není spolumajiteli dohodnuto jinak, má právo využívat vynález každý ze spolumajitelů patentu.<br/>
        (3 ) K platnému uzavření licenční smlouvy je třeba, není-li dohodnuto jinak, souhlasu všech spolumajitelů; každý
        ze spolumajitelů je oprávněn uplatňovat nároky z porušení práv z patentu samostatně.<br/>
        (4 ) K převodu patentu je zapotřebí souhlasu všech spolumajitelů. Spolumajitel je oprávněn bez souhlasu
        ostatních převést svůj podíl jen na některého ze spolumajitelů; na třetí osobu může převést svůj podíl jen v
        případě, že žádný ze spolumajitelů nepřijme ve lhůtě jednoho měsíce písemnou nabídku převodu.<br/>
        § 19<br/>
        Nabídka licence<br/>
        (1 ) Prohlásí-li u Úřadu přihlašovatel, popřípadě majitel patentu, že komukoli poskytne právo k využití vynálezu
        (nabídka licence), vznikne právo k využití vynálezu každému, kdo nabídku licence přijme a písemně to sdělí
        přihlašovateli nebo majiteli patentu. Úřad nabídku licence vyznačí v patentovém rejstříku.<br/>
        (2 ) Prohlášení o nabídce licence nelze vzít zpět.<br/>
        (3 ) Vznikem práva k využití vynálezu není dotčeno právo majitele patentu na úhradu ceny licence.<br/>
        (4 ) Za udržování platnosti patentu, k němuž majitel nabídl licenci podle odstavce 1 , se platí poplatky podle
        zvláštního právního předpisu pouze v poloviční výši.<br/>
        § 20<br/>
        Nucená licence<br/>
        (1 ) Nevyužívá-li majitel patentu bezdůvodně vynález vůbec nebo jej využívá nedostatečně a nepřijal-li v
        přiměřené lhůtě řádnou nabídku na uzavření licenční smlouvy, může Úřad na základě odůvodněné žádosti udělit
        nevýlučné právo k využívání vynálezu (nucenou licenci); tuto nucenou licenci nelze udělit před uplynutím 4 let
        od podání přihlášky vynálezu nebo 3 let od udělení patentu, přičemž platí lhůta, která uplyne později.<br/>
        (2 ) Nucená licence může být rovněž udělena, jestliže jsou dány důvody ohrožení důležitého veřejného zájmu.<br/>
        (3 ) V rozhodnutí o udělení nucené licence Úřad s přihlédnutím k okolnostem případu stanoví podmínky, rozsah a
        dobu trvání nucené licence. Nucenou licenci lze udělit převážně pro dodávky na domácí trh.<br/>
        (4 ) Nucenou licenci nelze převádět jinak než v rámci převodu podniku nebo jeho části, v níž podnikatel vynález
        na základě nucené licence využívá (dále jen "držitel nucené licence").<br/>
        (5 ) Držitel nucené licence se může v průběhu doby jejího trvání vzdát práva využívat vynález podáním učiněným u
        Úřadu; dnem doručení tohoto podání účinnost rozhodnutí o udělení nucené licence zaniká.<br/>
        (6 ) Na žádost majitele patentu, v níž doloží, že se změnily podmínky pro udělení nucené licence, aniž by bylo
        možné očekávat jejich opětovnou změnu, nebo že její držitel nucenou licenci po dobu jednoho roku nevyužívá,
        popřípadě neplní podmínky stanovené při udělení nucené licence, Úřad nucenou licenci zruší nebo změní podmínky,
        rozsah nebo dobu trvání nucené licence.<br/>
        (7 ) Udělením nucené licence není dotčeno právo majitele patentu na úhradu ceny licence. Není-li cena licence
        dohodnuta zúčastněnými stranami, stanoví ji na žádost soud s přihlédnutím k významu vynálezu a obvyklým cenám
        smluvních licencí v dané oblasti techniky.<br/>
        (8 ) Nucená licence se zapisuje do patentového rejstříku (§ 69).<br/>
        <br/>
        <br/>
        PŘEVODY PRÁV<br/>
        Druhým typem transakce je smlouva o převodu majetkových práv. Obdobou této smlouvy v oblasti hmotných statků je
        kupní smlouva. Pro oblast nehmotných statků nepoužíváme kategorii kupní smlouvy, protože právní úprava
        „vlastnických“ práv k nehmotným statkům se do značné míry liší od vlastnictví jiných hmotných předmětů.<br/>
        Zatímco vlastnictví hmotných předmětů bývá označováno jako neomezené právní panství nad věcí a zahrnuje
        zpravidla nejširší škálu práv včetně práva převodu, u duševního vlastnictví se rozlišují takzvaná osobnostní a
        majetková práva k těmto předmětům.<br/>
        Na rozdíl od anglosaské právní úpravy (tzv. copyright), kontinentální právní úpravy vymezují oblast osobnostních
        práv (například právo na autorství či původcovství) jako specifická práva autorů a původců neoddělitelně spjatá
        s těmito fyzickými osobami a v zásadě nepřevoditelná. Převoditelná jsou pouze práva majetková. Proto se smlouvy,
        které mají podobný ekonomický efekt jako prodej, označují jako smlouvy o převodu majetkových práv. Tyto smlouvy
        nejsou upraveny českým právem, uzavírají se zpravidla jako tzv. nepojmenované smlouvy.<br/>
        <br/>
        SPOLUVLASTNICKÉ DOHODY<br/>
        Ve vědeckém prostředí je poměrně běžné, že po skončení projektů spolupráce mezi výzkumnými organizacemi a
        soukromými podniky se vlastníkem výsledků projektů stává jedna nebo více výzkumných organizací společně s jedním
        nebo více soukromými podniky. V případech, kdy nedojde k vzájemnému převodu těchto podílů, tak se mezi stranami
        často uzavírá smlouva upravující nakládání a užívání těchto výsledků. Dle obecné právní úpravy totiž platí, že
        všichni spoluvlastníci zpravidla mají právo neomezeného využití spoluvlastněných nehmotných statků včetně jejich
        ekonomického využití.<br/>
        <br/>
        TYPICKÉ LICENCOVANÉ PŘEDMĚTY<br/>
        Jaké jsou typy nehmotných statků, které jsou typicky předmětem licenčních smluv? Typickými předměty práv jsou
        zejména vynálezy a jiná technická řešení chráněná nástroji průmyslového práva, tedy zejména patenty a užitné
        nebo průmyslové vzory. Z pohledu poskytovatele i nabyvatele licence jsou tyto nástroje ideální v tom smyslu, že
        dokud nedojde k výmazu těchto práv z příslušných rejstříků, není pochybnosti o tom, kdo je vlastníkem, tj.
        vykonavatelem majetkových práv k těmto předmětům. Tato práva se „dobře licencují“ také proto, že je poměrně
        jednoduché je ve smlouvě vymezit odkazem na zápis v příslušných rejstřících.<br/>
        Přinejmenším v oblasti vývoje software a v oblasti výtvarného a průmyslového designu se lze setkat s transferem
        předmětů chráněných jako autorská díla autorským zákonem. Je zapotřebí zdůraznit, že v zemích Evropské unie je v
        principu poměrně obtížné chránit software formou patentu, přestože to za určitých podmínek možné je.<br/>
        <br/>
        KNOW-HOW<br/>
        Dle aktuálně dostupných statistik vzrůstá v Česku význam licenčních smluv na know-how. Tradičně byla licence na
        know-how součástí nebo doplňkem licencí k patentům, kdy poskytovatel vedle práva na užití patentu předával
        nabyvateli také „obslužný“ soubor znalostí a postupů, které nepožívaly patentové ochrany.<br/>
        <br/>
        Know-how se rozumí tajný, podstatný a identifikovaný celek praktických nepatentovaných informací, které jsou
        výsledkem zkušeností dodavatele a jsou jím otestovány: v tomto kontextu se slovem „tajný“ rozumí, že know-how
        není obecně známé a snadno dostupné; slovem „podstatný“ se rozumí, že know-how je pro kupujícího podstatné a
        účelné pro používání, prodej nebo další prodej smluvního zboží a služeb; slovem „identifikovaný“ se rozumí, že
        know-how je popsáno dostatečně obsáhle tak, aby bylo možné ověřit, že splňuje kritéria tajnosti a
        podstatnosti.<br/>
        ZDROJ: NAŘÍZENÍ KOMISE (EU) č . 330/2010 ze dne 20. dubna 2010 o použití čl. 101 odst. 3 Smlouvy o fungování
        Evropské unie na kategorie vertikálních dohod a jednání ve vzájemné shodě.<br/>
        <br/>
        PODMÍNKY LICENČNÍCH A JINÝCH SMLUV<br/>
        Jednou z prvních otázek, kterou budeme muset v rámci jednání o licenční smlouvě interně i s partnerem
        diskutovat, je nepochybně to, zda licenci udělíme jako takzvanou licenci výhradní nebo nevýhradní. Jedná se o
        to, zda oprávnění užití předmětu licence bude mít pouze a výhradně nabyvatel dané licenční smlouvy, nebo zda nám
        bude umožněno nabízení licence i jiným subjektům.<br/>
        S otázkou výhradnosti a nevýhradnosti souvisí některé jiné aspekty licenční smlouvy. Jde zejména o otázku
        licenční odměny. Ta je u výhradních licencí typicky vyšší – někdy je uváděno, že výhradní licence bývají až
        desetkrát dražší než nevýhradní.<br/>
        S otázkou výhradnosti může souviset také právo udělení podlicence. U výhradních licencí se nabyvateli licence
        zpravidla uděluje oprávnění udělovat podlicence.<br/>
        Dále také může jít o možnost domluvy na tom, která ze stran se „stará“ o dodržování právní ochrany. Tu typicky
        zajišťuje poskytovatel licence. Někdy ale může být praktické, aby tuto odpovědnost na sebe převzal nabyvatel
        licence.<br/>
        Typickou náležitosti licenčních smluv je licenční odměna. Licenční odměna se skládá z prvků fixních a
        paušálních, jako jsou předplatba (downpayment) a minimální objemy licenčních poplatků, a z prvků flexibilních,
        jakými jsou zejména tzv. „royalties“, tedy prvky odměny kalkulované jako procento z hrubého či čistého výnosu
        nebo obratu. Licenční odměna by měla odrážet podmínky běžné v tržním prostředí.<br/>
        <br/>
        LICENČNÍ VYJEDNÁVÁNÍ<br/>
        V obecné rovině nepochybně platí, že v určitých aspektech se licenční vyjednávání neliší od vyjednávání v jiných
        obchodních záležitostech. Stejně tak platí, že vyjednávání o transakcích, v jejichž rámci je nakládáno s
        nehmotnými statky, vykazuje určitá specifika.<br/>
        V úvodních krocích lze doporučit provést důkladnou rešerši potenciálního partnera s ohledem na jeho ekonomickou
        způsobilost a spolehlivost. Standardním počátkem jednání o licenční nebo obdobné transakci je uzavření dohody o
        mlčenlivosti označované také jako NDA (Non Disclosure Agreement), DNDA (Disclosure and Non Disclosure Agreement)
        apod. Smyslem těchto dohod je ochrana duševního vlastnictví poskytovatele.
        <br/>
        <br/>
    </BasePdf>
};
export default LicensingModulePdf;
